<template>
  <div>
    <b-row>
      <b-col class="bold">
        Sillón
        <div>
          <span
              v-for="(item, i) in listaSillones"
              :key="i"
              style="text-align: start; color: #0069aa;"
          >
            {{ item.numeroSillon }}<span v-if="i < listaSillones.length - 1">, </span>
          </span>
        </div>
      </b-col>
      <b-col class="bold">
        Clínica
        <div>
          <span style="color: var(--color-dentalia); font-weight: bold">{{ nombreClinica }}</span>
        </div>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col>
        <span class="bold">Fechas</span>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col class="d-flex justify-content-center ml-3">
        <span class="pr-2 mt-2" style="color: rgb(142 142 142); font-weight: 600;">Desde</span>
        <b-form-datepicker
            style="height: 20px"
            dropright
            id="fecha-inicio"
            v-model="form.fechaInicio"
            placeholder="Fecha"
            @input="form.fechaFin = null"
            :min="new Date()"
        ></b-form-datepicker>
      </b-col>
      <b-col class="d-flex justify-content-center">
        <span class="pr-2 mt-2" style="color: rgb(142 142 142); font-weight: 600;">Hasta</span>
        <b-form-datepicker
            style="height: 20px"
            dropright
            id="fecha-fin"
            v-model="form.fechaFin"
            placeholder="Fecha"
            :disabled="form.fechaInicio == null"
            :min="form.fechaInicio"
        ></b-form-datepicker>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col>
        <span class="bold">Horarios</span>
      </b-col>
    </b-row>
    <div>
      <b-row class="mt-4 text-muted small font-weight-bold mb-2 text-center no-gutters">
        <b-col cols="1">DÍA</b-col>
        <b-col cols="4">APERTURA</b-col>
        <b-col cols="4">CIERRE</b-col>
        <b-col cols="3"></b-col>
      </b-row>
      <HorarioDiaRowSillon
          v-for="dia in listaDias"
          :key="dia.idDia"
          :dia="dia"
          :es-nuevo = "diasNuevos.has(dia.dia)"
      />
    </div>
    <br>
    <b-row>
      <b-col align="right">
        <b-button variant="outline-primary" pill :disabled="!formularioValido" @click="onGuardar">
          <span>Guardar</span>
        </b-button>
      </b-col>
      <b-col>
        <b-button variant="outline-secondary" pill @click="$emit('cerrar')">
          Cancelar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import HorarioDiaRowSillon from '../horarioClinica/edicionManual/HorarioDiaRowSillon.vue';

export default {
  name: "FormCrearSillon",
  components: { HorarioDiaRowSillon },
  props: {
    listaSillones: { type: Array, required: true },
    nombreClinica: { type: String, required: true },
    idClinica: { type: Number, required: true },
    diasOperativos: { type: Array, required: true },
    listaDias: { type: Array, required: true },
    listaHorariosSillon: { type: Array, required: true },
  },
  data: () => ({
    form: {
      fechaInicio: null,
      fechaFin: null,
    },
  }),
  mounted() {
    console.log('Lista de horarios sillón', this.listaHorariosSillon);
    console.log('Lista de horarios clinica', this.diasOperativos);

  },
  computed: {
    diasSeleccionados() {
      return this.listaDias.filter(d => d.seleccionado);
    },
    formularioValido() {
      return this.listaSillones.length > 0
          && this.form.fechaInicio != null
          && this.form.fechaFin != null
          && this.diasSeleccionados.length > 0;
    },
    diasNuevos() {
      const nuevos = new Set();
      const numerosSillon = this.listaSillones.map(s => s.numeroSillon);

      this.listaDias.forEach(dia => {
        if (dia.horaInicio === 0 && dia.horaFin === 0) return;

        const esNuevoParaAlgunSillon = numerosSillon.some(numSillon => {
          const match = this.listaHorariosSillon.find(e =>
              e.sillon === numSillon
              && e.sillonHabilitado === true
              && e.dia === dia.dia
          );
          if (!match) return true;
          return match.horaInicio !== dia.horaInicio
              || match.horaFin !== dia.horaFin;
        });
        if (esNuevoParaAlgunSillon) nuevos.add(dia.dia);
      });

      return nuevos;
    }
  },
  methods: {
    onGuardar() {
      this.$emit('guardar', {
        idClinica: this.idClinica,
        sillones: this.listaSillones.map(s => s.numeroSillon),
        dias: this.diasSeleccionados.map(d => d.dia),
        fechaInicio: this.form.fechaInicio,
        fechaFin: this.form.fechaFin,
        horaInicio: this.diasOperativos[0].horaInicio,
        horaFin: this.diasOperativos[0].horaFin,
      });
    },
  },
}
</script>
